<template>
  <div v-if="visible" class="stats-dialog-layer" @click.self="handleClose">
    <TanchuangFrame title="数据统计" v-slot="{ backgroundStyle }">
      <div class="stats-dialog" :style="backgroundStyle">
        <div class="stats-toolbar">
          <div class="stats-control stats-control--select">
            <button type="button" class="stats-select-trigger" @click="toggleMetricMenu">
              <span class="stats-select-text">{{ statisticsFilters.metric }}</span>
              <span class="stats-select-arrow" :class="{ 'is-open': metricMenuOpen }"></span>
            </button>
            <div v-if="metricMenuOpen" class="stats-select-menu">
              <button
                v-for="item in availableMetricOptions"
                :key="item"
                type="button"
                class="stats-select-option"
                :class="{ active: statisticsFilters.metric === item }"
                @click="selectMetric(item)"
              >
                {{ item }}
              </button>
            </div>
          </div>

          <div class="stats-control stats-control--date">
            <button type="button" class="stats-date-trigger" @click="toggleDateMenu('start')">
              <span class="stats-date-display">{{ formatDateDisplay(statisticsFilters.startDate) }}</span>
            </button>
            <div v-if="dateMenuOpen === 'start'" class="stats-date-panel">
              <div class="stats-date-panel-row">
                <label class="stats-date-field">
                  <span>年</span>
                  <div class="stats-date-select">
                    <button type="button" class="stats-date-select-trigger" @click="toggleDateFieldMenu('start-year')">
                      <span>{{ dateDraft.start.year }}</span>
                      <i class="stats-date-select-arrow" :class="{ 'is-open': dateFieldMenuOpen === 'start-year' }"></i>
                    </button>
                    <div v-if="dateFieldMenuOpen === 'start-year'" class="stats-date-select-menu">
                      <button
                        v-for="year in yearOptions"
                        :key="`start-${year}`"
                        type="button"
                        class="stats-date-select-option"
                        :class="{ active: dateDraft.start.year === year }"
                        @click="selectDateFieldValue('start', 'year', year)"
                      >
                        {{ year }}
                      </button>
                    </div>
                  </div>
                </label>
                <label class="stats-date-field">
                  <span>月</span>
                  <div class="stats-date-select">
                    <button type="button" class="stats-date-select-trigger" @click="toggleDateFieldMenu('start-month')">
                      <span>{{ dateDraft.start.month }}</span>
                      <i class="stats-date-select-arrow" :class="{ 'is-open': dateFieldMenuOpen === 'start-month' }"></i>
                    </button>
                    <div v-if="dateFieldMenuOpen === 'start-month'" class="stats-date-select-menu">
                      <button
                        v-for="month in monthOptions"
                        :key="`start-${month}`"
                        type="button"
                        class="stats-date-select-option"
                        :class="{ active: dateDraft.start.month === month }"
                        @click="selectDateFieldValue('start', 'month', month)"
                      >
                        {{ month }}
                      </button>
                    </div>
                  </div>
                </label>
                <label class="stats-date-field">
                  <span>日</span>
                  <div class="stats-date-select">
                    <button type="button" class="stats-date-select-trigger" @click="toggleDateFieldMenu('start-day')">
                      <span>{{ dateDraft.start.day }}</span>
                      <i class="stats-date-select-arrow" :class="{ 'is-open': dateFieldMenuOpen === 'start-day' }"></i>
                    </button>
                    <div v-if="dateFieldMenuOpen === 'start-day'" class="stats-date-select-menu">
                      <button
                        v-for="day in startDayOptions"
                        :key="`start-${day}`"
                        type="button"
                        class="stats-date-select-option"
                        :class="{ active: dateDraft.start.day === day }"
                        @click="selectDateFieldValue('start', 'day', day)"
                      >
                        {{ day }}
                      </button>
                    </div>
                  </div>
                </label>
              </div>
              <div class="stats-date-actions">
                <button type="button" class="stats-date-action stats-date-action--ghost" @click="closeDateMenu">取消</button>
                <button type="button" class="stats-date-action" @click="applyDateDraft('start')">确定</button>
              </div>
            </div>
          </div>

          <span class="stats-date-sep">—</span>

          <div class="stats-control stats-control--date">
            <button type="button" class="stats-date-trigger" @click="toggleDateMenu('end')">
              <span class="stats-date-display">{{ formatDateDisplay(statisticsFilters.endDate) }}</span>
            </button>
            <div v-if="dateMenuOpen === 'end'" class="stats-date-panel">
              <div class="stats-date-panel-row">
                <label class="stats-date-field">
                  <span>年</span>
                  <div class="stats-date-select">
                    <button type="button" class="stats-date-select-trigger" @click="toggleDateFieldMenu('end-year')">
                      <span>{{ dateDraft.end.year }}</span>
                      <i class="stats-date-select-arrow" :class="{ 'is-open': dateFieldMenuOpen === 'end-year' }"></i>
                    </button>
                    <div v-if="dateFieldMenuOpen === 'end-year'" class="stats-date-select-menu">
                      <button
                        v-for="year in yearOptions"
                        :key="`end-${year}`"
                        type="button"
                        class="stats-date-select-option"
                        :class="{ active: dateDraft.end.year === year }"
                        @click="selectDateFieldValue('end', 'year', year)"
                      >
                        {{ year }}
                      </button>
                    </div>
                  </div>
                </label>
                <label class="stats-date-field">
                  <span>月</span>
                  <div class="stats-date-select">
                    <button type="button" class="stats-date-select-trigger" @click="toggleDateFieldMenu('end-month')">
                      <span>{{ dateDraft.end.month }}</span>
                      <i class="stats-date-select-arrow" :class="{ 'is-open': dateFieldMenuOpen === 'end-month' }"></i>
                    </button>
                    <div v-if="dateFieldMenuOpen === 'end-month'" class="stats-date-select-menu">
                      <button
                        v-for="month in monthOptions"
                        :key="`end-${month}`"
                        type="button"
                        class="stats-date-select-option"
                        :class="{ active: dateDraft.end.month === month }"
                        @click="selectDateFieldValue('end', 'month', month)"
                      >
                        {{ month }}
                      </button>
                    </div>
                  </div>
                </label>
                <label class="stats-date-field">
                  <span>日</span>
                  <div class="stats-date-select">
                    <button type="button" class="stats-date-select-trigger" @click="toggleDateFieldMenu('end-day')">
                      <span>{{ dateDraft.end.day }}</span>
                      <i class="stats-date-select-arrow" :class="{ 'is-open': dateFieldMenuOpen === 'end-day' }"></i>
                    </button>
                    <div v-if="dateFieldMenuOpen === 'end-day'" class="stats-date-select-menu">
                      <button
                        v-for="day in endDayOptions"
                        :key="`end-${day}`"
                        type="button"
                        class="stats-date-select-option"
                        :class="{ active: dateDraft.end.day === day }"
                        @click="selectDateFieldValue('end', 'day', day)"
                      >
                        {{ day }}
                      </button>
                    </div>
                  </div>
                </label>
              </div>
              <div class="stats-date-actions">
                <button type="button" class="stats-date-action stats-date-action--ghost" @click="closeDateMenu">取消</button>
                <button type="button" class="stats-date-action" @click="applyDateDraft('end')">确定</button>
              </div>
            </div>
          </div>

          <button type="button" class="stats-submit" :disabled="loading" @click="handleQuery">
            {{ loading ? '查询中...' : '查询' }}
          </button>

          <button type="button" class="stats-export" :disabled="exporting" @click="handleExport">
            {{ exporting ? '导出中...' : '导出' }}
          </button>

          <button type="button" class="stats-summary" :disabled="summarizing" @click="handleSummaryExport">
            {{ summarizing ? '生成中...' : '数据汇总' }}
          </button>
        </div>

        <div class="stats-content">
          <div class="stats-table-wrap">
            <table class="stats-table">
              <colgroup>
                <col :style="{ width: currentTableLayout.indexWidth }">
                <col :style="{ width: currentTableLayout.dateWidth }">
                <col
                  v-for="column in currentDisplayColumns"
                  :key="`stats-col-${column.key}`"
                  :style="{ width: column.width }"
                >
              </colgroup>
              <thead>
                <tr>
                  <th :style="{ width: currentTableLayout.indexWidth }">序号</th>
                  <th :style="{ width: currentTableLayout.dateWidth }">{{ currentDateColumnLabel }}</th>
                  <th
                    v-for="column in currentDisplayColumns"
                    :key="column.key"
                    :class="{ 'stats-col--left': column.align === 'left' }"
                    :style="{ width: column.width }"
                  >
                    {{ column.label }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in pagedDisplayRows" :key="item.__rowKey || `${item.sentDate}-${index}`">
                  <td>{{ (statisticsFilters.pageNum - 1) * statisticsFilters.pageSize + index + 1 }}</td>
                  <td>{{ item.sentDate }}</td>
                  <td
                    v-for="column in currentDisplayColumns"
                    :key="`${item.__rowKey || item.sentDate}-${column.key}`"
                    :class="{ 'stats-col--left': column.align === 'left' }"
                  >
                    {{ item[column.key] }}
                  </td>
                </tr>
                <tr v-if="!loading && !pagedDisplayRows.length">
                  <td :colspan="currentDisplayColumns.length + 2" class="stats-empty">暂无数据</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="stats-pagination">
            <div class="stats-page-size">
              <span>每页</span>
              <div class="stats-page-size-select">
                <button type="button" class="stats-page-size-trigger" @click="togglePageSizeMenu">
                  <span>{{ statisticsFilters.pageSize }}</span>
                  <i class="stats-page-size-arrow" :class="{ 'is-open': pageSizeMenuOpen }"></i>
                </button>
                <div v-if="pageSizeMenuOpen" class="stats-page-size-menu">
                  <button
                    v-for="size in pageSizeOptions"
                    :key="size"
                    type="button"
                    class="stats-page-size-option"
                    :class="{ active: statisticsFilters.pageSize === size }"
                    @click="selectPageSize(size)"
                  >
                    {{ size }}
                  </button>
                </div>
              </div>
              <span>条</span>
            </div>
            <button
              type="button"
              class="stats-page-btn"
              :disabled="statisticsFilters.pageNum <= 1 || loading"
              @click="changePage(statisticsFilters.pageNum - 1)"
            >
              上一页
            </button>
            <span class="stats-page-info">
              第 {{ statisticsFilters.pageNum }} / {{ totalPages }} 页，共 {{ total }} 条
            </span>
            <button
              type="button"
              class="stats-page-btn"
              :disabled="statisticsFilters.pageNum >= totalPages || loading"
              @click="changePage(statisticsFilters.pageNum + 1)"
            >
              下一页
            </button>
          </div>
        </div>
      </div>
    </TanchuangFrame>
  </div>
</template>

<script>
import { exportStatisticsData, exportStatisticsSummary, listStatisticsData } from '@/api/datav'
import TanchuangFrame from '@/components/common/TanchuangFrame.vue'

function formatDateValue(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

function parseDateValue(value) {
  const [year, month, day] = String(value || '').split('-').map(Number)
  return {
    year: Number.isFinite(year) ? year : new Date().getFullYear(),
    month: Number.isFinite(month) ? month : 1,
    day: Number.isFinite(day) ? day : 1
  }
}

function getDayCount(year, month) {
  return new Date(year, month, 0).getDate()
}

function getDefaultDateRange() {
  const endDate = new Date()
  endDate.setDate(endDate.getDate() + 1)

  const lastMonthSameDay = new Date(endDate)
  lastMonthSameDay.setMonth(lastMonthSameDay.getMonth() - 1)

  if (lastMonthSameDay.getDate() !== endDate.getDate()) {
    lastMonthSameDay.setDate(0)
  }

  return {
    startDate: formatDateValue(lastMonthSameDay),
    endDate: formatDateValue(endDate)
  }
}

const DEFAULT_STATISTICS_METRIC_OPTIONS = [
  '监管运输工具数量',
  '报关单数量',
  '货值',
  '货运量',
  '税收金额',
  '跨境电商监管保税',
  '跨境电商监管非保税',
  '市场采购',
  '易货贸易',
  '备案数量',
  '外贸情况',
  '事中查验',
  '属地查检',
  '进出境旅客情况',
  '外勤执法',
  '在岗情况',
  '检验检疫签证',
  '进境粮食检疫监管',
  '稽核查作业情况',
  '查验超4小时',
  '通关时效分析',
  '查验异常数据',
  '已取样未出结果'
]

function getResolvedMetricOptions(metricOptions) {
  return Array.isArray(metricOptions) && metricOptions.length
    ? metricOptions.slice()
    : DEFAULT_STATISTICS_METRIC_OPTIONS.slice()
}

function getResolvedDefaultMetric(metricOptions, defaultMetric) {
  const options = getResolvedMetricOptions(metricOptions)
  if (defaultMetric && options.includes(defaultMetric)) {
    return defaultMetric
  }
  return options[0] || ''
}

export default {
  name: 'StatisticsDialog',
  components: { TanchuangFrame },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    metricOptions: {
      type: Array,
      default: () => []
    },
    defaultMetric: {
      type: String,
      default: ''
    },
    source: {
      type: String,
      default: ''
    }
  },
  data() {
    const defaultDateRange = getDefaultDateRange()
    const initialMetric = getResolvedDefaultMetric(this.metricOptions, this.defaultMetric)
    return {
      statisticsFilters: {
        metric: initialMetric,
        startDate: defaultDateRange.startDate,
        endDate: defaultDateRange.endDate,
        pageNum: 1,
        pageSize: 10
      },
      pageSizeOptions: [10, 20, 50, 100],
      pageSizeMenuOpen: false,
      metricMenuOpen: false,
      dateMenuOpen: '',
      dateFieldMenuOpen: '',
      dateDraft: {
        start: parseDateValue(defaultDateRange.startDate),
        end: parseDateValue(defaultDateRange.endDate)
      },
      rawTotal: 0,
      rows: [],
      total: 0,
      loading: false,
      exporting: false,
      summarizing: false
    }
  },
  computed: {
    availableMetricOptions() {
      return getResolvedMetricOptions(this.metricOptions)
    },
    yearOptions() {
      const currentYear = new Date().getFullYear()
      const years = []
      for (let year = currentYear - 5; year <= 2035; year++) {
        years.push(year)
      }
      return years
    },
    monthOptions() {
      return Array.from({ length: 12 }, (_, index) => index + 1)
    },
    isPivotMetric() {
      return Boolean(this.getPivotConfig(this.statisticsFilters.metric))
    },
    startDayOptions() {
      return Array.from(
        { length: getDayCount(this.dateDraft.start.year, this.dateDraft.start.month) },
        (_, index) => index + 1
      )
    },
    endDayOptions() {
      return Array.from(
        { length: getDayCount(this.dateDraft.end.year, this.dateDraft.end.month) },
        (_, index) => index + 1
      )
    },
    totalPages() {
      return Math.max(Math.ceil(this.total / this.statisticsFilters.pageSize), 1)
    },
    currentDateColumnLabel() {
      return this.statisticsFilters.metric === '稽核查作业情况'
        ? '作业计时开始时间'
        : '日期'
    },
    currentTableColumns() {
      const metric = this.statisticsFilters.metric

      if (['监管运输工具数量', '报关单数量', '货值', '货运量', '税收金额', '跨境电商监管保税', '跨境电商监管非保税', '市场采购', '易货贸易', '备案数量', '事中查验', '属地查检', '进出境旅客情况'].includes(metric)) {
        return { label: '名称', value: '数值' }
      }

      if (metric === '外勤执法') {
        return { label: '工号', value: '作业内容' }
      }

      if (metric === '在岗情况') {
        return { label: '人员', value: '状态' }
      }

      if (metric === '检验检疫签证') {
        return { label: '签证类型', value: '数量' }
      }

      if (metric === '进境粮食检疫监管') {
        return { label: '指标', value: '数值' }
      }

      if (metric === '查验超4小时') {
        return { label: '报关单号', value: '超四小时原因' }
      }

      if (metric === '通关时效分析') {
        return { label: '名称', value: '时长' }
      }

      if (metric === '查验异常数据') {
        return { label: '报关单号', value: '问题表现' }
      }

      if (metric === '已取样未出结果') {
        return { label: '报关单号', value: '申请单号' }
      }

      return { label: '名称', value: '数值' }
    },
    currentDisplayColumns() {
      const metric = this.statisticsFilters.metric
      const pivotConfig = this.getPivotConfig(metric)
      if (pivotConfig) {
        return pivotConfig.columns
      }

      if (metric === '保税维修') {
        return [
          {
            key: 'itemLabel',
            label: '入区待维修货物品名',
            width: this.currentTableLayout.labelWidth,
            align: 'left'
          },
          {
            key: 'itemValue',
            label: '数量（台/件）',
            width: this.currentTableLayout.valueWidth,
            align: 'center'
          },
          {
            key: 'remark',
            label: '货值（万元）',
            width: this.currentTableLayout.extraWidth,
            align: 'center'
          }
        ]
      }

      if (metric === '查验超4小时') {
        return [
          {
            key: 'itemLabel',
            label: '报关单号',
            width: this.currentTableLayout.labelWidth,
            align: 'center'
          },
          {
            key: 'itemValue',
            label: '超四小时原因',
            width: this.currentTableLayout.valueWidth,
            align: 'left'
          },
          {
            key: 'remark',
            label: '备注',
            width: this.currentTableLayout.extraWidth,
            align: 'left'
          }
        ]
      }

      if (metric === '稽核查作业情况') {
        return [
          {
            key: 'itemLabel',
            label: '事项',
            width: this.currentTableLayout.labelWidth,
            align: 'left'
          },
          {
            key: 'itemValue',
            label: '在办',
            width: this.currentTableLayout.valueWidth,
            align: 'center'
          },
          {
            key: 'remark',
            label: '已办',
            width: this.currentTableLayout.extraWidth,
            align: 'center'
          }
        ]
      }

      if (metric === '外贸情况') {
        return [
          {
            key: 'itemLabel',
            label: '项目',
            width: this.currentTableLayout.labelWidth,
            align: 'left'
          },
          {
            key: 'itemValue',
            label: '贸易额',
            width: this.currentTableLayout.valueWidth,
            align: 'center'
          },
          {
            key: 'remark',
            label: '占比',
            width: this.currentTableLayout.extraWidth,
            align: 'center'
          }
        ]
      }

      return [
        {
          key: 'itemLabel',
          label: this.currentTableColumns.label,
          width: this.currentTableLayout.labelWidth,
          align: this.currentTableLayout.labelAlign
        },
        {
          key: 'itemValue',
          label: this.currentTableColumns.value,
          width: this.currentTableLayout.valueWidth,
          align: this.currentTableLayout.valueAlign
        }
      ]
    },
    displayRows() {
      const pivotConfig = this.getPivotConfig(this.statisticsFilters.metric)
      if (!pivotConfig) {
        return (this.rows || []).map((item, index) => ({
          ...item,
          __rowKey: `${item.sentDate || 'date'}-${index}`
        }))
      }

      const grouped = {}
      ;(this.rows || []).forEach((item, index) => {
        const key = item.sentDate || `date-${index}`
        if (!grouped[key]) {
          grouped[key] = {
            __rowKey: `${key}-${index}`,
            sentDate: item.sentDate || ''
          }
          pivotConfig.columns.forEach(column => {
            grouped[key][column.key] = ''
          })
        }
        const targetKey = pivotConfig.mapping[item.itemLabel]
        if (targetKey) {
          grouped[key][targetKey] = item.itemValue
        }
      })

      return Object.values(grouped)
    },
    pagedDisplayRows() {
      return this.displayRows
    },
    currentTableLayout() {
      const metric = this.statisticsFilters.metric

      if (this.getPivotConfig(metric)) {
        const pivotConfig = this.getPivotConfig(metric)
        return {
          indexWidth: '8%',
          dateWidth: pivotConfig.dateWidth || '16%',
          labelWidth: '0%',
          valueWidth: '',
          labelAlign: 'left',
          valueAlign: 'center'
        }
      }

      if (metric === '外勤执法') {
        return {
          indexWidth: '10%',
          dateWidth: '20%',
          labelWidth: '18%',
          valueWidth: '52%',
          labelAlign: 'center',
          valueAlign: 'left'
        }
      }

      if (metric === '在岗情况') {
        return {
          indexWidth: '10%',
          dateWidth: '20%',
          labelWidth: '38%',
          valueWidth: '32%',
          labelAlign: 'left',
          valueAlign: 'center'
        }
      }

      if (metric === '检验检疫签证') {
        return {
          indexWidth: '8%',
          dateWidth: '18%',
          labelWidth: '42%',
          valueWidth: '32%',
          labelAlign: 'left',
          valueAlign: 'center'
        }
      }

      if (metric === '进境粮食检疫监管') {
        return {
          indexWidth: '8%',
          dateWidth: '18%',
          labelWidth: '44%',
          valueWidth: '30%',
          labelAlign: 'left',
          valueAlign: 'center'
        }
      }

      if (metric === '稽核查作业情况') {
        return {
          indexWidth: '8%',
          dateWidth: '18%',
          labelWidth: '32%',
          valueWidth: '20%',
          extraWidth: '22%',
          labelAlign: 'left',
          valueAlign: 'center'
        }
      }

      if (metric === '保税维修') {
        return {
          indexWidth: '8%',
          dateWidth: '18%',
          labelWidth: '34%',
          valueWidth: '18%',
          extraWidth: '22%',
          labelAlign: 'left',
          valueAlign: 'center'
        }
      }

      if (metric === '外贸情况') {
        return {
          indexWidth: '8%',
          dateWidth: '18%',
          labelWidth: '34%',
          valueWidth: '20%',
          extraWidth: '20%',
          labelAlign: 'left',
          valueAlign: 'center'
        }
      }

      if (metric === '查验超4小时') {
        return {
          indexWidth: '8%',
          dateWidth: '18%',
          labelWidth: '24%',
          valueWidth: '32%',
          extraWidth: '18%',
          labelAlign: 'center',
          valueAlign: 'left'
        }
      }

      if (metric === '查验异常数据') {
        return {
          indexWidth: '8%',
          dateWidth: '18%',
          labelWidth: '24%',
          valueWidth: '50%',
          labelAlign: 'center',
          valueAlign: 'left'
        }
      }

      if (metric === '已取样未出结果') {
        return {
          indexWidth: '8%',
          dateWidth: '18%',
          labelWidth: '30%',
          valueWidth: '44%',
          labelAlign: 'center',
          valueAlign: 'center'
        }
      }

      return {
        indexWidth: '10%',
        dateWidth: '20%',
        labelWidth: '35%',
        valueWidth: '35%',
        labelAlign: 'left',
        valueAlign: 'center'
      }
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.syncMetricSelection(true)
        this.handleQuery()
      } else {
        this.metricMenuOpen = false
      }
    },
    metricOptions() {
      this.syncMetricSelection()
    },
    defaultMetric() {
      this.syncMetricSelection(true)
    }
  },
  methods: {
    resolveDefaultMetricValue() {
      return getResolvedDefaultMetric(this.metricOptions, this.defaultMetric)
    },
    syncMetricSelection(forceDefault = false) {
      const options = this.availableMetricOptions
      if (!options.length) {
        this.statisticsFilters.metric = ''
        return
      }
      if (forceDefault || !options.includes(this.statisticsFilters.metric)) {
        this.statisticsFilters.metric = this.resolveDefaultMetricValue()
      }
    },
    handleClose() {
      this.closeDateMenu()
      this.pageSizeMenuOpen = false
      this.$emit('close')
    },
    toggleMetricMenu() {
      this.metricMenuOpen = !this.metricMenuOpen
      this.closeDateMenu()
      this.pageSizeMenuOpen = false
    },
    selectMetric(metric) {
      this.statisticsFilters.metric = metric
      this.metricMenuOpen = false
      this.handleQuery()
    },
    toggleDateMenu(type) {
      this.metricMenuOpen = false
      this.dateFieldMenuOpen = ''
      this.pageSizeMenuOpen = false
      if (this.dateMenuOpen === type) {
        this.dateMenuOpen = ''
        return
      }
      this.syncDateDraft(type)
      this.dateMenuOpen = type
    },
    closeDateMenu() {
      this.dateMenuOpen = ''
      this.dateFieldMenuOpen = ''
    },
    syncDateDraft(type) {
      this.dateDraft[type] = parseDateValue(this.statisticsFilters[`${type}Date`])
    },
    applyDateDraft(type) {
      const draft = this.dateDraft[type]
      const maxDay = getDayCount(draft.year, draft.month)
      const day = Math.min(draft.day, maxDay)
      this.statisticsFilters[`${type}Date`] = formatDateValue(new Date(draft.year, draft.month - 1, day))
      this.closeDateMenu()
    },
    toggleDateFieldMenu(key) {
      this.dateFieldMenuOpen = this.dateFieldMenuOpen === key ? '' : key
    },
    selectDateFieldValue(type, field, value) {
      this.dateDraft[type][field] = value
      const maxDay = getDayCount(this.dateDraft[type].year, this.dateDraft[type].month)
      if (this.dateDraft[type].day > maxDay) {
        this.dateDraft[type].day = maxDay
      }
      this.dateFieldMenuOpen = ''
    },
    togglePageSizeMenu() {
      this.metricMenuOpen = false
      this.closeDateMenu()
      this.pageSizeMenuOpen = !this.pageSizeMenuOpen
    },
    async selectPageSize(size) {
      this.statisticsFilters.pageSize = size
      this.pageSizeMenuOpen = false
      await this.handlePageSizeChange()
    },
    getPivotConfig(metric) {
      const map = {
        监管运输工具数量: {
          dateWidth: '16%',
          columns: [
          ['roadIn', '进口', '进口（单）'],
          ['roadOut', '出口', '出口（单）'],
          ['railwayTrain', '全部列数', '全部列数（列）'],
          ['railwayContainer', '全部标箱', '全部标箱（个）']
          ]
        },
        报关单数量: {
          dateWidth: '18%',
          columns: [
          ['importValue', '进口', '进口（票）'],
          ['exportValue', '出口', '出口（票）']
          ]
        },
        货值: {
          dateWidth: '18%',
          columns: [
          ['importValue', '进口', '进口（亿）'],
          ['exportValue', '出口', '出口（亿）']
          ]
        },
        货运量: {
          dateWidth: '18%',
          columns: [
          ['importValue', '进口', '进口（吨）'],
          ['exportValue', '出口', '出口（吨）']
          ]
        },
        税收金额: {
          dateWidth: '18%',
          columns: [
          ['importValue', '进口', '进口（万元）'],
          ['exportValue', '出口', '出口（万元）']
          ]
        },
        跨境电商监管保税: {
          dateWidth: '18%',
          columns: [
          ['tradeValue', '1210贸易额', '1210贸易额（万）'],
          ['rateValue', '同比', '同比（%）']
          ]
        },
        跨境电商监管非保税: {
          dateWidth: '16%',
          columns: [
          ['value9610', '9610贸易额', '9610贸易额（万）'],
          ['value9710', '9710贸易额', '9710贸易额（万）'],
          ['value9810', '9810贸易额', '9810贸易额（万）']
          ]
        },
        市场采购: {
          dateWidth: '18%',
          columns: [
          ['tradeValue', '贸易额', '贸易额（亿）'],
          ['ticketValue', '票数', '票数（票）']
          ]
        },
        易货贸易: {
          dateWidth: '15%',
          columns: [
          ['importTrade', '易货贸易额进口', '易货贸易额进口（亿）'],
          ['exportTrade', '易货贸易额出口', '易货贸易额出口（亿）'],
          ['ticketValue', '票数', '票数（票）'],
          ['totalTrade', '易货贸易额', '易货贸易额（亿）']
          ]
        },
        备案数量: {
          dateWidth: '16%',
          columns: [
          ['transportValue', '运输工具', '运输工具（个）'],
          ['formValue', '报关单位', '报关单位（个）'],
          ['specialValue', '特定资质', '特定资质（个）']
          ]
        },
        检验检疫签证: {
          dateWidth: '16%',
          columns: [
          ['plantValue', '植物检疫证书', '植物检疫证书'],
          ['veterinarianValue', '兽医卫生证书', '兽医卫生证书'],
          ['healthValue', '健康证书', '健康证书'],
          ['hygieneValue', '卫生证书', '卫生证书'],
          ['allValue', '总证书', '总证书']
          ]
        },
        进境粮食检疫监管: {
          dateWidth: '14%',
          columns: [
          ['transferCount', '调运联系单-调运数量', '调运数量（次）'],
          ['transferProcessed', '调运联系单-已加工数量', '调运已加工（吨）'],
          ['offcutsWeight', '下脚料-下脚料重量', '下脚料重量（kg）'],
          ['offcutsHandled', '下脚料-已处理重量', '已处理重量（kg）'],
          ['processingInput', '粮食加工-调入总量', '调入总量（吨）'],
          ['processingDone', '粮食加工-已加工数量', '粮食已加工（吨）']
          ]
        },
        事中查验: {
          dateWidth: '16%',
          columns: [
          ['pendingValue', '待查验量', '待查验量（个）'],
          ['todayValue', '已查验量', '已查验量（个）'],
          ['rateValue', '查获率', '查获率（%）']
          ]
        },
        属地查检: {
          dateWidth: '16%',
          columns: [
          ['pendingValue', '待查验量', '待查验量（个）'],
          ['todayValue', '已查验量', '已查验量（个）'],
          ['rateValue', '发现异常（批）', '发现异常（批）']
          ]
        },
        进出境旅客情况: {
          dateWidth: '14%',
          columns: [
          ['entryValue', '进境', '进境（人次）'],
          ['exitValue', '出境', '出境（人次）'],
          ['quarantineValue', '检疫传染病', '检疫传染病（例）'],
          ['detectionValue', '监测传染病人数', '监测传染病人数'],
          ['averageValue', '一般疾病', '一般疾病']
          ]
        },
        通关时效分析: {
          dateWidth: '18%',
          columns: [
          ['importHours', '进口（小时）', '进口（小时）'],
          ['exportHours', '出口（小时）', '出口（小时）']
          ]
        },
        区外加工贸易: {
          dateWidth: '18%',
          columns: [
          ['tradeValue', '进出口贸易额（万元）', '进出口贸易额（万元）'],
          ['yoyRate', '同比增长率（%）', '同比增长率（%）']
          ]
        },
        出口商品车: {
          dateWidth: '18%',
          columns: [
          ['exportQuantity', '出口数量（台）', '出口数量（台）'],
          ['tradeValue', '贸易值（亿元）', '贸易值（亿元）']
          ]
        },
        '保税+TIR': {
          dateWidth: '16%',
          columns: [
          ['vehicleCount', '发运车辆数（辆）', '发运车辆数（辆）'],
          ['freightTonnage', '货运量（吨）', '货运量（吨）'],
          ['tradeValue', '货值（万元）', '货值（万元）']
          ]
        },
        '铁路+跨境电商（9610）': {
          dateWidth: '16%',
          columns: [
          ['containerCount', '集装箱数量（个）', '集装箱数量（个）'],
          ['manifestCount', '清单数量（票）', '清单数量（票）'],
          ['tradeValue', '货值（万元）', '货值（万元）']
          ]
        },
        先查后装: {
          dateWidth: '16%',
          columns: [
          ['releaseManifestCount', '放行清单数（票）', '放行清单数（票）'],
          ['inspectionManifestCount', '查验清单数（票）', '查验清单数（票）'],
          ['vehicleCount', '车辆数（辆）', '车辆数（辆）']
          ]
        }
      }

      const config = map[metric]
      if (!config) {
        return null
      }

      return {
        dateWidth: config.dateWidth,
        columns: config.columns.map(([key, , label]) => ({
          key,
          label,
          width: this.resolvePivotColumnWidth(metric, key),
          align: 'center'
        })),
        mapping: config.columns.reduce((result, [key, sourceLabel]) => {
          result[sourceLabel] = key
          return result
        }, {})
      }
    },
    resolvePivotColumnWidth(metric, key) {
      const widthMap = {
        跨境电商监管保税: {
          tradeValue: '38%',
          rateValue: '36%'
        },
        报关单数量: {
          importValue: '37%',
          exportValue: '37%'
        },
        货值: {
          importValue: '37%',
          exportValue: '37%'
        },
        货运量: {
          importValue: '37%',
          exportValue: '37%'
        },
        税收金额: {
          importValue: '37%',
          exportValue: '37%'
        },
        通关时效分析: {
          importHours: '37%',
          exportHours: '37%'
        },
        监管运输工具数量: {
          roadIn: '23%',
          roadOut: '23%',
          railwayTrain: '23%',
          railwayContainer: '23%'
        },
        检验检疫签证: {
          plantValue: '13%',
          veterinarianValue: '16%',
          healthValue: '13%',
          hygieneValue: '13%',
          allValue: '12%'
        },
        进境粮食检疫监管: {
          transferCount: '14%',
          transferProcessed: '14%',
          offcutsWeight: '14%',
          offcutsHandled: '14%',
          processingInput: '14%',
          processingDone: '14%'
        },
        进出境旅客情况: {
          entryValue: '16%',
          exitValue: '16%',
          quarantineValue: '16%',
          detectionValue: '18%',
          averageValue: '16%'
        },
        区外加工贸易: {
          tradeValue: '38%',
          yoyRate: '36%'
        },
        出口商品车: {
          exportQuantity: '38%',
          tradeValue: '36%'
        },
        '保税+TIR': {
          vehicleCount: '28%',
          freightTonnage: '28%',
          tradeValue: '28%'
        },
        '铁路+跨境电商（9610）': {
          containerCount: '28%',
          manifestCount: '28%',
          tradeValue: '28%'
        },
        先查后装: {
          releaseManifestCount: '28%',
          inspectionManifestCount: '28%',
          vehicleCount: '28%'
        }
      }

      return (widthMap[metric] && widthMap[metric][key]) || ''
    },
    formatDateDisplay(value) {
      if (!value) {
        return ''
      }

      const [year, month, day] = value.split('-')
      return `${year}/${Number(month)}/${Number(day)}`
    },
    buildPayload() {
      return {
        source: this.source || null,
        metric: this.statisticsFilters.metric,
        startDate: this.statisticsFilters.startDate || null,
        endDate: this.statisticsFilters.endDate || null,
        pageNum: this.statisticsFilters.pageNum,
        pageSize: this.statisticsFilters.pageSize
      }
    },
    async handleQuery() {
      this.statisticsFilters.pageNum = 1
      if (!this.statisticsFilters.metric) {
        this.rows = []
        this.rawTotal = 0
        this.total = 0
        return
      }
      await this.fetchRows()
    },
    async fetchRows() {
      this.loading = true
      try {
        const result = await listStatisticsData(this.buildPayload())
        if (![0, 200].includes(Number(result.code))) {
          throw new Error(result.msg || '统计数据返回异常')
        }
        this.rows = Array.isArray(result.rows) ? result.rows : []
        this.rawTotal = Number(result.total) || 0
        this.total = this.rawTotal
      } catch (error) {
        this.rows = []
        this.rawTotal = 0
        this.total = 0
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async changePage(pageNum) {
      this.statisticsFilters.pageNum = pageNum
      await this.fetchRows()
    },
    async handlePageSizeChange() {
      this.statisticsFilters.pageNum = 1
      await this.fetchRows()
    },
    async handleExport() {
      if (!this.statisticsFilters.metric) {
        return
      }
      this.exporting = true
      try {
        const { blob, filename } = await exportStatisticsData({
          ...this.buildPayload(),
          pageNum: 1,
          pageSize: 999999
        })
        const link = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error(error)
      } finally {
        this.exporting = false
      }
    },
    async handleSummaryExport() {
      this.summarizing = true
      try {
        const { blob, filename } = await exportStatisticsSummary({
          ...this.buildPayload(),
          metrics: this.availableMetricOptions,
          pageNum: 1,
          pageSize: 999999
        })
        const link = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error(error)
      } finally {
        this.summarizing = false
      }
    }
  }
}
</script>

<style scoped>
.stats-dialog-layer {
  position: absolute;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(3, 16, 43, 0.55);
}

.stats-dialog {
  position: relative;
  width: 100%;
  height: 100%;
  padding:
    clamp(104px, 5.6vw, 128px)
    clamp(48px, 2.7vw, 66px)
    clamp(30px, 2.8vw, 40px);
  box-sizing: border-box;
}

.stats-toolbar {
  position: relative;
  z-index: 5;
  display: grid;
  grid-template-columns: 1.18fr 0.78fr auto 0.78fr 0.62fr 0.62fr 0.78fr;
  align-items: center;
  gap: 0.55vw;
}

.stats-control {
  position: relative;
  height: 1.9vw;
  border: 0.05vw solid rgba(84, 197, 255, 0.3);
  border-radius: 0.48vw;
  background: linear-gradient(180deg, rgba(18, 120, 231, 0.88), rgba(5, 66, 159, 0.82));
  box-shadow: inset 0 0 0.58vw rgba(122, 230, 255, 0.16);
  overflow: visible;
}

.stats-control--date {
  display: flex;
  align-items: center;
  justify-content: center;
}

.stats-date-trigger {
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 0.48vw;
  background: transparent;
  cursor: pointer;
}

.stats-control--select::before {
  display: none;
}

.stats-select-trigger {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.82vw;
  border: 0;
  border-radius: 0.48vw;
  color: #effaff;
  font-size: 0.76vw;
  background: transparent;
  outline: none;
  cursor: pointer;
}

.stats-select-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stats-select-arrow {
  flex: 0 0 auto;
  width: 0.44vw;
  height: 0.28vw;
  margin-left: 0.6vw;
  background: rgba(236, 249, 255, 0.92);
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  transition: transform 0.2s ease;
}

.stats-select-arrow.is-open {
  transform: rotate(180deg);
}

.stats-select-menu {
  position: absolute;
  top: calc(100% + 0.28vw);
  left: 0;
  right: 0;
  z-index: 12;
  max-height: 16vw;
  padding: 0.3vw;
  border: 0.05vw solid rgba(84, 197, 255, 0.42);
  border-radius: 0.48vw;
  background: linear-gradient(180deg, rgba(7, 56, 132, 0.98), rgba(4, 30, 83, 0.98));
  box-shadow: 0 0.6vw 1.2vw rgba(0, 0, 0, 0.24);
  overflow-y: auto;
}

.stats-select-option {
  width: 100%;
  min-height: 2vw;
  padding: 0.42vw 0.58vw;
  border: 0;
  border-radius: 0.32vw;
  color: rgba(231, 247, 255, 0.9);
  font-size: 0.78vw;
  text-align: left;
  background: transparent;
  cursor: pointer;
}

.stats-select-option:hover,
.stats-select-option.active {
  color: #ffffff;
  background: linear-gradient(180deg, rgba(36, 147, 255, 0.96), rgba(23, 96, 219, 0.9));
}

.stats-date-display {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  padding: 0 0.82vw;
  box-sizing: border-box;
  color: #effaff;
  font-size: 0.74vw;
  line-height: 1.9vw;
  text-align: center;
  pointer-events: none;
}

.stats-date-panel {
  position: absolute;
  top: calc(100% + 0.3vw);
  left: 0;
  z-index: 12;
  width: 16vw;
  padding: 0.72vw;
  border: 0.05vw solid rgba(84, 197, 255, 0.42);
  border-radius: 0.56vw;
  background: linear-gradient(180deg, rgba(7, 56, 132, 0.98), rgba(4, 30, 83, 0.98));
  box-shadow: 0 0.6vw 1.2vw rgba(0, 0, 0, 0.24);
}

.stats-date-panel-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.42vw;
}

.stats-date-field {
  display: flex;
  flex-direction: column;
  gap: 0.24vw;
  color: #dff4ff;
  font-size: 0.66vw;
}

.stats-date-select {
  position: relative;
}

.stats-date-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 1.9vw;
  padding: 0 0.42vw;
  border: 0.05vw solid rgba(102, 217, 255, 0.28);
  border-radius: 0.34vw;
  color: #effaff;
  font-size: 0.72vw;
  background: linear-gradient(180deg, rgba(18, 120, 231, 0.68), rgba(5, 66, 159, 0.62));
  cursor: pointer;
}

.stats-date-select-arrow {
  width: 0.34vw;
  height: 0.22vw;
  background: rgba(236, 249, 255, 0.92);
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  transition: transform 0.2s ease;
}

.stats-date-select-arrow.is-open {
  transform: rotate(180deg);
}

.stats-date-select-menu {
  position: absolute;
  top: calc(100% + 0.18vw);
  left: 0;
  right: 0;
  z-index: 2;
  max-height: 8.8vw;
  padding: 0.18vw;
  border: 0.05vw solid rgba(84, 197, 255, 0.42);
  border-radius: 0.34vw;
  background: linear-gradient(180deg, rgba(7, 56, 132, 0.98), rgba(4, 30, 83, 0.98));
  box-shadow: 0 0.5vw 1vw rgba(0, 0, 0, 0.22);
  overflow-y: auto;
}

.stats-date-select-option {
  width: 100%;
  min-height: 1.58vw;
  border: 0;
  border-radius: 0.24vw;
  color: rgba(231, 247, 255, 0.9);
  font-size: 0.7vw;
  text-align: center;
  background: transparent;
  cursor: pointer;
}

.stats-date-select-option:hover,
.stats-date-select-option.active {
  color: #ffffff;
  background: linear-gradient(180deg, rgba(36, 147, 255, 0.96), rgba(23, 96, 219, 0.9));
}

.stats-date-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.42vw;
  margin-top: 0.72vw;
}

.stats-date-action {
  min-width: 3.2vw;
  height: 1.7vw;
  border: 0;
  border-radius: 0.34vw;
  color: #f3fcff;
  font-size: 0.7vw;
  background: linear-gradient(180deg, rgba(44, 189, 255, 0.95), rgba(10, 108, 224, 0.86));
  cursor: pointer;
}

.stats-date-action--ghost {
  background: linear-gradient(180deg, rgba(25, 95, 176, 0.95), rgba(8, 61, 128, 0.86));
}

.stats-date-sep {
  color: rgba(234, 245, 255, 0.92);
  font-size: 1.1vw;
  text-align: center;
}

.stats-submit,
.stats-export,
.stats-summary,
.stats-page-btn {
  height: 1.9vw;
  border: 0.05vw solid rgba(134, 230, 255, 0.64);
  border-radius: 0.48vw;
  color: #f3fcff;
  font-size: 0.78vw;
  font-weight: 700;
  background: linear-gradient(180deg, rgba(44, 189, 255, 0.95), rgba(10, 108, 224, 0.86));
  box-shadow: inset 0 0 0.72vw rgba(183, 244, 255, 0.18);
  cursor: pointer;
}

.stats-submit:disabled,
.stats-export:disabled,
.stats-summary:disabled,
.stats-page-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.stats-content {
  display: flex;
  flex-direction: column;
  gap: 1vw;
  margin-top: 1.3vw;
  height: calc(100% - 3.9vw);
}

.stats-table-wrap {
  flex: 1;
  min-height: 0;
  padding: 0.6vw 0.9vw;
  border: 0.05vw solid rgba(84, 197, 255, 0.24);
  border-radius: 0.42vw;
  background: rgba(5, 40, 98, 0.34);
  overflow: auto;
}

.stats-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.stats-table th,
.stats-table td {
  padding: 0.7vw 0.8vw;
  border-bottom: 0.05vw solid rgba(84, 197, 255, 0.18);
  color: #effaff;
  font-size: 0.82vw;
  text-align: center;
  word-break: break-word;
}

.stats-table th {
  color: #bfe8ff;
  font-size: 0.88vw;
  font-weight: 700;
}

.stats-col--left {
  text-align: left !important;
}

.stats-table thead th:nth-child(n + 3),
.stats-table tbody td:nth-child(n + 3) {
  padding-left: 0.48vw;
  padding-right: 0.48vw;
}

.stats-empty {
  padding: 3vw 0;
  color: rgba(218, 239, 255, 0.76);
}

.stats-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.8vw;
}

.stats-page-size {
  display: inline-flex;
  align-items: center;
  gap: 0.34vw;
  color: #d7efff;
  font-size: 0.76vw;
}

.stats-page-size-select {
  position: relative;
}

.stats-page-size-trigger {
  width: 3.6vw;
  height: 1.9vw;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.34vw;
  border: 0.05vw solid rgba(134, 230, 255, 0.42);
  border-radius: 0.36vw;
  color: #effaff;
  font-size: 0.72vw;
  background: linear-gradient(180deg, rgba(18, 120, 231, 0.82), rgba(5, 66, 159, 0.76));
  cursor: pointer;
}

.stats-page-size-arrow {
  width: 0.34vw;
  height: 0.22vw;
  background: rgba(236, 249, 255, 0.92);
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  transition: transform 0.2s ease;
}

.stats-page-size-arrow.is-open {
  transform: rotate(180deg);
}

.stats-page-size-menu {
  position: absolute;
  top: calc(100% + 0.18vw);
  left: 0;
  right: 0;
  z-index: 12;
  padding: 0.18vw;
  border: 0.05vw solid rgba(84, 197, 255, 0.42);
  border-radius: 0.34vw;
  background: linear-gradient(180deg, rgba(7, 56, 132, 0.98), rgba(4, 30, 83, 0.98));
  box-shadow: 0 0.5vw 1vw rgba(0, 0, 0, 0.22);
}

.stats-page-size-option {
  width: 100%;
  min-height: 1.58vw;
  border: 0;
  border-radius: 0.24vw;
  color: rgba(231, 247, 255, 0.9);
  font-size: 0.7vw;
  text-align: center;
  background: transparent;
  cursor: pointer;
}

.stats-page-size-option:hover,
.stats-page-size-option.active {
  color: #ffffff;
  background: linear-gradient(180deg, rgba(36, 147, 255, 0.96), rgba(23, 96, 219, 0.9));
}

.stats-page-info {
  color: #d7efff;
  font-size: 0.78vw;
}
</style>
